module.exports = __webpack_public_path__ + "static/media/iqra6in1.38804da9.png";